import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from 'ddmo-storybook-lib';

@Component({
    selector: 'app-impersonation-header',
    imports: [ButtonComponent],
    templateUrl: './impersonation-header.component.html',
    styleUrl: './impersonation-header.component.scss'
})
export class ImpersonationHeaderComponent {
  userName!: string;
  impersonatedUser!: string;

constructor(private router: Router){

}

  ngOnInit(): void {
     this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
     this.userName = localStorage.getItem("userName") ?? ""
  }

  stopImpersonate(){
    localStorage.setItem('impersonatedUser', '');
    localStorage.setItem('isProviderImpersonated', 'false'); 
    localStorage.removeItem('loggedUserDetails');
    this.setImpersateUser();
    this.router.navigate(['/admin'])
  }
  setImpersateUser(){
    this.userName = localStorage.getItem("userName") ?? ""   
    this.impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
  }
}
